import { DealRoom } from 'models/DealRoom';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useCallback, useContext } from 'react';
import usePremiumFeatures from './usePremiumFeatures';

export default function useCanAccessDataRoom() {
  const { isUltraAdmin } = useContext(CurrentUserContext);

  const { getHasUnlockPremiumFeatures } = usePremiumFeatures();

  return useCallback(
    (dealRoom: Partial<DealRoom>, hasDataRoomAccess: boolean) =>
      isUltraAdmin ||
      (getHasUnlockPremiumFeatures(dealRoom) && hasDataRoomAccess),
    [isUltraAdmin, getHasUnlockPremiumFeatures],
  );
}
